export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/58f7098676423874f446e84ca38b07ca.jpg" 
          alt="Luxury Mercedes Maybach Sprinter in Houston"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-32 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-white/95 backdrop-blur-sm px-5 py-2.5 rounded-full mb-8">
              <i className="ri-vip-crown-line text-teal-600 text-lg"></i>
              <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">Houston's Premier Luxury Transportation</span>
            </div>

            <h1 className="text-5xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight mb-6">
              ARRIVE IN<br />
              <span className="text-teal-400">REGAL</span><br />
              LUXURY
            </h1>

            <p className="text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
              Mercedes Maybach Sprinter Vans | Up to 10 Passengers | Professional Chauffeur Service
            </p>

            <p className="text-base lg:text-lg text-gray-300 mb-10 leading-relaxed max-w-2xl">
              Experience the perfect blend of luxury and affordability with our premium fleet of Mercedes-Benz Sprinter vans. Professional drivers and tailored service ensure you arrive in style—wherever you're headed in Greater Houston.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button onClick={() => scrollToSection('contact')} className="bg-black text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-900 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap">
                Book Your Ride
              </button>
              <button onClick={() => scrollToSection('fleet')} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap">
                View Fleet
              </button>
            </div>

            <div className="mt-12 flex items-center justify-center lg:justify-start">
              <a href="tel:7139996733" className="flex items-center space-x-3 text-white hover:text-teal-300 transition-colors cursor-pointer group">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center group-hover:bg-teal-500 transition-colors">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm text-gray-300">Call Us Now</div>
                  <div className="text-2xl font-bold whitespace-nowrap">713-999-6733</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-black/70 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="grid grid-cols-3 gap-6 text-center">
            <div className="border-r border-white/20 last:border-r-0">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1">10+</div>
              <div className="text-xs sm:text-sm text-gray-300">Passengers</div>
            </div>
            <div className="border-r border-white/20 last:border-r-0">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1">24/7</div>
              <div className="text-xs sm:text-sm text-gray-300">Service</div>
            </div>
            <div>
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1">Premium</div>
              <div className="text-xs sm:text-sm text-gray-300">Fleet</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
